import React, { useEffect, useRef } from 'react';

const OBSERVER_OPTIONS = { threshold: 0.05, rootMargin: '0px 0px -50px 0px' };

const Reveal = ({ children, delay = 0, className = '' }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const obs = new IntersectionObserver((entries, observer) => {
      entries.filter((entry) => entry.isIntersecting).forEach((entry) => {
        setTimeout(() => entry.target.classList.add('is-visible'), delay);
        observer.unobserve(entry.target);
      });
    }, OBSERVER_OPTIONS);
    obs.observe(el);
    return () => obs.disconnect();
  }, [delay, ref]);
  return (
    <div ref={ref} className={`reveal ${className}`}>
      {children}
    </div>
  );
};

export default Reveal;
